import React, { useEffect, useRef } from "react";

import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import "./Home.css";
// import { Offline, Online } from "react-detect-offline";
import { isLoggedIn } from '../../authUtils';
import { useGetAllProductsQuery } from "../../redux/APIs/productApi";
import { getAllCollections } from "../../redux/actions/collectionActions";
import { getRecentlyViewedProducts } from "../../redux/actions/recentlyViewedActions";
import Footer from "../layout/Footer/Footer";
import AnimatedSection from "./AnimatedSection";
import CollectionCards from "./CollectionCards";
import HeroAnimation from "./HomeComponents/HeroAnimation";



function Home() {
  const dispatch = useDispatch();
  // const { collections, loading, error } = useSelector(state => state.collections);
  // const recentlyViewedProducts = useSelector(state => state.recentlyViewed.products);
  // console.log(recentlyViewedProducts);
  const { slug } = useParams();
  const fadeInElementsRef = useRef([]);

  // const { data: ProductsByCol, isLoading } = useGetAllProductsQuery();
  // const { data: allProducts, isLoading: allProductsLoading, isFetching } = useGetAllProductsQuery();

  // console.log('Products by Collection:', allProducts);
  // console.log('Products by Collection:', allProductsLoading);
  // console.log('Products by Collection Fetch status:', isFetching);

  // console.log(collections);
  useEffect(() => {
    dispatch(getAllCollections());
    if(isLoggedIn){
      dispatch(getRecentlyViewedProducts());
    }
    
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    const handleScroll = () => {
      fadeInElementsRef.current.forEach((element) => {
        if (element) {
          const elementPosition = element.getBoundingClientRect().top;
          const windowHeight = window.innerHeight;
          const scrollPosition = window.scrollY;
  
          // Calculate the threshold position based on the window height
          const threshold = windowHeight * 0.8;
  
          // Check if the element is within the threshold
          if (elementPosition < threshold) {
            element.classList.add('h2-fade-in');
          } else {
            element.classList.remove('h2-fade-in');
          }
        }
      });
    };
  
    // Add event listener for scroll
    window.addEventListener('scroll', handleScroll);
  
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
// console.log(collections);

const {data: allProducts, isloading} = useGetAllProductsQuery();

console.log('Products', allProducts);

  return (
    <div className="home-wrapper rounded-lg">
      {/* <HeroCarousel/> */}
      <HeroAnimation/>
      <AnimatedSection/>
      <CollectionCards/>
      <Footer/>
    </div>
  );
}

export default Home;

